import {
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  TextField,
  CardMedia,
  Button,
} from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import { Search } from "@mui/icons-material";
import color from "../../components/utils/Colors";
import { useNavigate } from "react-router-dom";

const AdminCourseVideo = () => {
  const isSmallScreen = useMediaQuery("(max-width:1050px)");
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        backgroundImage: "url('/images/logo 2.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "auto",
        margin: isSmallScreen ? "10px" : "30px",
        marginTop: "0px",
        paddingTop: "20px",
        gap: "3%",
        borderRadius: "10px",
        flexDirection: isSmallScreen ? "column" : "row",
      }}
    >
      <AdminSidebar />

      <Box
        sx={{
          flex: 1,
          borderRadius: "16px",
        }}
      >
        {/* <TextField
          className="input-root2"
          placeholder="Search..."
          size="small"
          InputProps={{
            startAdornment: (
              <IconButton>
                <Search />
              </IconButton>
            ),
          }}
          sx={{
            width: { xs: "100%", md: "auto" },
          }}
        /> */}

        <Box
          sx={{
            position: "relative",
            background: color.firstColor,
            borderRadius: "16px",
            height: "fit-content",
            my: 4,
          }}
        >
          <Box
            component="img"
            src="/assets/Welcome Bar.svg"
            alt="Welcome Bar"
            sx={{
              width: "100%",
              height: 200,
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              top: { xs: "18%", sm: "25%" },
              left: "3%",
              fontSize: "32px",
              fontWeight: "bold",
            }}
          >
            Course Video
          </Typography>
          <Typography
            sx={{
              color: "white",
              position: "absolute",
              left: "3%",
              maxWidth: "62%",
              top: { xs: "44%", sm: "50%" },
            }}
          >
            Review course from teachers
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: isSmallScreen ? "center" : "space-between",
            p: isSmallScreen ? 1 : 4,
            pt: 1,
            borderRadius: "12px",
          }}
        >
          <h2
            style={{
              color: color.textColor,
              textAlign: "center",
              width: "100%",
              paddingLeft: "10px",
              margin: "0px",
            }}
          >
            Python
          </h2>

          <CardMedia
            component="img"
            image="/assets/Video-img.png"
            alt="Course Video"
            sx={{
              // width: { xs: "100px", sm: "120px", md: "140px" },
              // height: { xs: "100px", sm: "120px", md: "140px" },
              backgroundColor: "transparent",
              p: 4,
              pt: 2,
            }}
          />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width={"100%"}
            mt={8}
          >
            <Button
              onClick={() => {
                navigate(-1);
              }}
              id="button1"
              style={{ borderRadius: "2px" }}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminCourseVideo;
